import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CalendarClock } from "lucide-react";

export const AutopayDialog = ({ inv, onClose, onSave }) => {
  const [date, setDate] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (inv) setDate(inv.autopay_date || ""); }, [inv]);
  const save = async () => { setBusy(true); await onSave(inv, date); setBusy(false); };
  return (
    <Dialog open={!!inv} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="autopay-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-heading"><CalendarClock className="h-5 w-5 text-sky-600" /> Autopay</DialogTitle>
          <DialogDescription>
            {inv?.vendor_name}{inv?.invoice_number ? ` · #${inv.invoice_number}` : ""}. This invoice is already set up to be paid automatically — it skips approval and check printing and is marked Paid on the autopay date.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-1.5">
          <Label>Autopay date *</Label>
          <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid="autopay-date-input" />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={save} disabled={!date || busy} data-testid="autopay-save-btn">Save Autopay</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
